import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import Services from "../../../API/common/sharedServices";
import Button from "../../../shared/button/button";
import { ButtonWrapperStyles } from "../../../shared/button/ButtonWrapperStyles";
import Loader from "../../../shared/loaders/simpleLoader";
import ApprovedIcon from "../../../assets/icons/stepsIcons/ApprovedIcon";
import { AgreementContainer } from "../styledComponents/agreementStyles/agreement.style";
import { useGlobalContext } from "../../../context/globalContext";
import {
  mobileSessionStorage,
  setMobileSessionStorage,
} from "../../../utils/helpers/mobileSessionStorage";
import { rejectEvent } from "../../../utils/helpers/successEvent";
import MarketingPurposeConsent from "../markentingPurposConsent";
import SafeHtml from "../SafeHtml";

const SimpleAgreement = (props) => {
  // if importing for new form check push on handleConfirm and change it
  const {
    setRedirectUrl,
    serviceType,
    pathForRedirect,
    marketingPurposeConsent,
  } = props || {};
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [agreements, setAgreements] = useState([]);

  const history = useHistory();
  const { catchError } = useGlobalContext();
  const params = useParams();
  const mobile = params?.mobile?.toLowerCase() === "mobile";
  const userId = params?.userId;
  const handleReject = () => {
    document.dispatchEvent(rejectEvent);
    if (!mobile) {
      if (i18n.language === "ka") {
        window.open("http://www.procreditbank.ge/ge");
      } else {
        window.open("http://www.procreditbank.ge/en");
      }
    }
  };

  const handleConfirm = () => {
    if (!loading && agreements.length !== 0) {
      setLoading(true);
      Services.getAuthLink(i18n.language, serviceType, userId)
        .then((res) => {
          sessionStorage.setItem("localToken", res.data.localToken);
          sessionStorage.setItem("servicetype", serviceType);
          setRedirectUrl(res.data.redirectUrl);
          // push to identification page logic
          history.push(`${pathForRedirect}/Identomat/${i18n.language}`);
          setLoading(false);
        })
        .catch((err) => catchError(err, { withoutRedirect: true }));
    }
  };

  const getRenderedAgreements = () => {
    if (!marketingPurposeConsent) return agreements;

    if (!agreements.length) return agreements;

    return agreements.slice(0, -1);
  };

  useEffect(() => {
    setLoading(true);
    if (mobile || mobileSessionStorage) setMobileSessionStorage(true);
    Services.getAgreements(i18n.language, serviceType)
      .then((response) =>
        setAgreements(response.data?.length ? response.data : [])
      )
      .catch((err) => catchError(err, { withoutRedirect: true }))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  const renderedAgreements = getRenderedAgreements();

  return (
    <AgreementContainer className="w-full">
      {loading ? (
        <Loader />
      ) : (
        <div className="agreementWrapper ">
          {renderedAgreements.map((agreement, index) => (
            <div className={"agreementTextWrapper"} key={index}>
              <div className="mr-4">
                <ApprovedIcon />
              </div>
              <SafeHtml as="span" html={agreement} />
            </div>
          ))}

          {marketingPurposeConsent ? (
            <MarketingPurposeConsent
              isAgreed={marketingPurposeConsent?.isAgreed}
              handleClick={marketingPurposeConsent?.handleClick}
              text={agreements?.[agreements.length - 1]}
            />
          ) : null}
          <ButtonWrapperStyles>
            <Button
              variant={"inherit"}
              style={{ marginRight: "5px" }}
              onClick={handleReject}
            >
              {t("Cancel")}
            </Button>
            <Button
              variant={
                loading || agreements.length === 0 ? "disabled" : "primary"
              }
              onClick={handleConfirm}
            >
              {t("confirmation")}
            </Button>
          </ButtonWrapperStyles>
        </div>
      )}
    </AgreementContainer>
  );
};

export default SimpleAgreement;
